"use client";
import Image from "next/image";
import Link from "next/link";
import { AspectRatio, Box, Stack, SimpleGrid } from "@chakra-ui/react";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading } from "@/elements";
import { CYBER_SEC_TECH_STACK_CONSTANTS } from "./constants";

const CyberSecStack = () => {
  const HeadingVariant = useHeadingVariant();
  const { title, list } = CYBER_SEC_TECH_STACK_CONSTANTS;
  return (
    <Stack gap={10} mb={6}>
      <Heading as="h2" variant={HeadingVariant} textAlign={"center"} px={2}>
        {title}
      </Heading>
      <SimpleGrid
        columns={{ base: 3, md: 6 }}
        columnGap={{ base: 3, sm: 4 }}
        justifyContent={"center"}
        alignItems={"center"}
        rowGap={10}
        px={{ base: 3, xl: 28, "2xl": 40 }}
        py={10}
      >
        {list.map((stack, index) => {
          return (
            <Link key={index} href={stack.link} target="_blank" rel="noopener noreferrer">
              <Box _hover={{ opacity: 0.8 }} cursor="pointer">
                <AspectRatio ratio={2 / 1} maxW="160px" position="relative">
                  <Image
                    src={stack.logo}
                    alt={stack.name}
                    fill
                    sizes="(min-width: 62em) 130px, (min-width: 30em) 100px, 80px"
                    style={{
                      objectFit: "contain",
                      objectPosition: "center",
                    }}
                    loading="lazy"
                  />
                </AspectRatio>
              </Box>
            </Link>
          );
        })}
      </SimpleGrid>
    </Stack>
  );
};

export default CyberSecStack;
